import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/reglements`;

function getRequestConfig() {
  const token = localStorage.getItem("token");

  return {
    headers: token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {},
  };
}

export const getReglements = async () => {
  const response = await axios.get(
    `${apiUrl}/allreglements`,
    getRequestConfig(),
  );

  return response.data;
};

export const getReglementById = async (id) => {
  const response = await axios.get(
    `${apiUrl}/${id}`,
    getRequestConfig(),
  );

  return response.data;
};

export const getTotalAchats = async () => {
  const response = await axios.get(
    `${apiUrl}/totalachats`,
    getRequestConfig(),
  );

  return response.data;
};

export const getReglementUserOptions = async () => {
  const response = await axios.get(
    `${apiUrl}/users-options`,
    getRequestConfig(),
  );

  return response.data;
};

export const getReglementsByUser = async (userId) => {
  const response = await axios.get(
    `${apiUrl}/achats/user/${userId}`,
    getRequestConfig(),
  );

  return response.data;
};

export const createReglement = async (reglementData) => {
  const response = await axios.post(
    apiUrl,
    reglementData,
    getRequestConfig(),
  );

  return response.data;
};

export const updateReglement = async (id, reglementData) => {
  const response = await axios.put(
    `${apiUrl}/${id}`,
    reglementData,
    getRequestConfig(),
  );

  return response.data;
};

export const updateStatutReglements = async (
  ids,
  statutReglement,
) => {
  const response = await axios.put(
    `${apiUrl}/updatestatutreglements`,
    {
      ids,
      statut_reglement: statutReglement,
    },
    getRequestConfig(),
  );

  return response.data;
};

export const deleteReglement = async (id) => {
  const response = await axios.delete(
    `${apiUrl}/${id}`,
    getRequestConfig(),
  );

  return response.data;
};